@if ((allItems.length || macItems.length || win64Items.length || winItems.length) && product.stringId != "notionmobile3") {
  <div id="bundled_downloads">
    @if (s1OrNotion) {
      <span>
        {{ "product_detail.install_instructions.step2" | translate }}
        <br />
        <br />
      </span>
    }
    @if (allItems.length) {
      <div>
        @if (product.categoryId == "software") {
          <button
            class="brand-btn-reverse"
            (keydown.enter)="showHideDownloads($event)"
            (click)="showHideDownloads($event)"
            [translate]="showAllBundledDownloads ? 'product_detail.hide_all_bundled_downloads' : 'product_detail.show_all_bundled_downloads'"
            [translateParams]="{ count: allItems.length }"
          ></button>
        }
        @if (showAllBundledDownloads || product.categoryId == "extension") {
          <div class="grid-container pad-10 m-t-20">
            @for (dl of allItems; track dl) {
              <myp-download-tile [product]="product" [download]="dl"></myp-download-tile>
            }
          </div>
        }
      </div>
    }
    @if (!allItems.length) {
      <div>
        <button
          class="brand-btn-reverse"
          (keyup.enter)="showHideDownloads($event)"
          (click)="showHideDownloads($event)"
          [translate]="showAllBundledDownloads ? 'product_detail.hide_all_bundled_downloads' : 'product_detail.show_all_bundled_downloads'"
          [translateParams]="{ count: macItems.length }"
        ></button>
        @if (showAllBundledDownloads && (myOs == "mac" || showAllSystems)) {
          <div>
            @if (showAllSystems) {
              <h4>Mac</h4>
            }
            <div class="grid-container pad-10">
              @for (dl of macItems; track dl) {
                <myp-download-tile [product]="product" [download]="dl"></myp-download-tile>
              }
            </div>
          </div>
        }
        @if (showAllBundledDownloads && win64Items.length && (myOs != "mac" || showAllSystems)) {
          <div>
            @if (showAllSystems) {
              <h4>Windows (64 bit)</h4>
            }
            <div class="grid-container pad-10">
              @for (dl of win64Items; track dl) {
                <myp-download-tile [product]="product" [download]="dl"></myp-download-tile>
              }
            </div>
          </div>
        }
        @if (showAllBundledDownloads && winItems.length && (myOs != "mac" || showAllSystems)) {
          <div>
            @if (showAllSystems) {
              <h4>Windows</h4>
            }
            <div class="grid-container pad-10">
              @for (dl of winItems; track dl) {
                <myp-download-tile [product]="product" [download]="dl"></myp-download-tile>
              }
            </div>
          </div>
        }
        @if (showAllBundledDownloads) {
          <div class="installer_btn_actions">
            <button class="small-btn" (click)="showAllSystems = !showAllSystems" [translate]="showAllSystems ? 'product_detail.show_my_system' : 'product_detail.show_all_systems'"></button>
          </div>
        }
      </div>
    }
  </div>
}
